import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/prd-categories/all-with-products-to-display';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export interface GetAllCategoriesWithProductsSuccessResponse {
    data: paths[url]['get']['responses']['200']['content']['application/json'];
}

/**
 * Requests endpoint to get all product categories that have products.
 */
export const useGetAllCategoriesWithProducts = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const { setAllCategoriesWithProducts, setIsLoadingAllCategoriesWithProducts } = useData();

    const request = async () => {
        setIsLoadingAllCategoriesWithProducts(true);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetAllCategoriesWithProductsSuccessResponse = await response.json();

            setAllCategoriesWithProducts(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setIsLoadingAllCategoriesWithProducts(false);
        }
    };

    return { request };
};
